export default __webpack_public_path__ + "static/media/n2.9d581126.svg";